import React, { forwardRef, useImperativeHandle, useState } from 'react'
import cn from 'classnames'

import st from './index.scss'

export default forwardRef(function Modal({ children, show = null, onCancel = () => {}, className, ...props }, ref) {
    const [innerShow, setShow] = useState(false)

    useImperativeHandle(ref, () => ({
        // 外部调用此方法直接显示错误 如果传入参数 则按参数显示错误信息
        show: () => setShow(true),
        hide: () => setShow(false)
    }))

    // 如果没有外部传入show 则使用内部状态
    if (show === null && !innerShow) {
        return null
    }

    // 如果外部传入了show 则使用外部的show
    if (show !== null && !show) {
        return null
    }

    return <div className={cn(st['bg'], className)} onClick={() => onCancel()} {...props}>
        {children}
    </div>
})
